import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsStitcherComponent } from './simple-icons-stitcher.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsStitcherComponent ],
    exports:      [ SimpleIconsStitcherComponent ],
    bootstrap:    []
})
export class SimpleIconsStitcherModule {}
